import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationLeadStatusOrder(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<
    unknown,
    unknown,
    { statusId: number; statusOrder: number }
  >,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      statusId,
      statusOrder,
    }: {
      statusId: number;
      statusOrder: number;
    }) => api.leadApi.editStatusColumnOrder(statusId, statusOrder),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
    },
    ...mutationOpts,
  });
}
